// import { useState } from "react";
// import Sidebar from "./Sidebar";
// import Header from "./MainDashboard/Header";
// import { Outlet } from "react-router-dom";
// import { useGlobalContext } from "../GlobalContext";
// import LogoutWatcher from "./Utils/LogoutWatcher";

// export default function MainLayout() {
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const { showOld, setShowOld } = useGlobalContext();

//   return (
//     <div className="flex h-screen overflow-hidden">
//       <LogoutWatcher type="admin" />

//       <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
//       <div className="flex-1 flex flex-col">
     
//           <Header showOld={showOld} setShowOld={setShowOld} />

//         <div className="flex-1 overflow-y-auto p-2 ">
//           <Outlet />
//         </div>
//       </div>
//     </div>
//   );
// }


import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./MainDashboard/Header";
import { Outlet, useLocation } from "react-router-dom";
import { useGlobalContext } from "../GlobalContext";
import LogoutWatcher from "./Utils/LogoutWatcher";
import AccessDeniedPage from "./Utils/AccessDeniendPage";

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const {
    showOld,
    setShowOld,
    isAccessDenied,
    setIsAccessDenied,
    accessDeniedMessage,
    setAccessDeniedMessage,
  } = useGlobalContext();

  useEffect(() => {
    setIsAccessDenied(false);
    setAccessDeniedMessage("");
  }, [location.pathname, setIsAccessDenied, setAccessDeniedMessage]);

  return (
    <div className="flex h-screen overflow-hidden">
      <LogoutWatcher type="admin" />

      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      <div className="flex-1 flex flex-col">
        <Header showOld={showOld} setShowOld={setShowOld} />

        <div className="flex-1 overflow-y-auto p-2">
          {isAccessDenied ? (
            <AccessDeniedPage
              message={accessDeniedMessage || "Access Denied"}
              subMessage="You do not have permission to access this section."
            />
          ) : (
            <Outlet />
          )}
        </div>
      </div>
    </div>
  );
}